module.exports = __webpack_public_path__ + "media/fonts/fa-regular-400-db4c0d1bb23c0f9b661a44e20f434dd0.woff";